export const customHeadForPartner = {
  main: "Add Partner Details",
  sub: " ",
};

export const customHeadForRep = {
    main: "Add Representative Details",
    sub: " ",
  };
